import { Injectable } from "@angular/core";
import {
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { TabCacheService } from "../shared/tabs/tab-cache.service";
import { CloudIdStorageService } from "../shared/cloud/cloud-id-storage.service";
import { ActivatedTabService } from "../shared/tabs/activated-tab.service";

@Injectable({
  providedIn: "root",
})
export class ActivatedTabGuard implements CanActivateChild {
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const tabId = this.getTabId(next);
    if (tabId) {
      return this.tabInCurrentCloud(tabId);
    } else {
      return true;
    }
  }

  constructor(
    private tabCacheService: TabCacheService,
    private cloudIdStorageService: CloudIdStorageService,
    private activatedTabService: ActivatedTabService,
    private router: Router
  ) {}

  navigateByUrl(url, extras?) {
    return this.router.navigateByUrl(url, extras);
  }

  getTabId(route: ActivatedRouteSnapshot) {
    return this.activatedTabService.getTabId(route);
  }

  loadCloudId() {
    return this.cloudIdStorageService.loadCloudId();
  }

  tabInCurrentCloud(tabId) {
    const cachedTab = this.getCachedTabById(tabId);

    return !cachedTab || cachedTab.cloudId === this.loadCloudId();
  }

  getCachedTabById(tabId) {
    return this.tabCacheService.getTabById(tabId);
  }
}
